module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert callout error",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data-closable": "",
      "role": "error-information"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Dismiss alert",
      "type": "button",
      "data-close": ""
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-251caf30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/Callout.vue
// module id = 465
// module chunks = 2